var map = {
	"./20coperti/header.jpg": "432f",
	"./20coperti/slides/card.jpg": "9e2c",
	"./20coperti/slides/logo.jpg": "bf12",
	"./20coperti/slides/logo_construction.jpg": "13a9",
	"./20coperti/slides/pattern.jpg": "2995",
	"./20coperti/slides/sign_mockup.jpg": "5da0",
	"./20coperti/slides/sketch.jpg": "8bfc",
	"./20coperti/slides/table.jpg": "10b4",
	"./20coperti/thumbnail.jpg": "3233",
	"./20dicembre/header.jpg": "f59a",
	"./20dicembre/slides/fontsystem.jpg": "d34b",
	"./20dicembre/slides/mockup1.jpg": "7f3b",
	"./20dicembre/slides/mockup2.jpg": "8085",
	"./20dicembre/slides/mountain.jpg": "9246",
	"./20dicembre/slides/snowman.jpg": "4690",
	"./20dicembre/slides/soundcloud.jpg": "0e20",
	"./20dicembre/slides/spread.jpg": "43f9",
	"./20dicembre/thumbnail.jpg": "8b58",
	"./eulost/header.jpg": "c3f4",
	"./eulost/thumbnail.jpg": "01a5",
	"./fungisamurai/header.jpg": "fc43",
	"./fungisamurai/slides/head.jpg": "d3cb",
	"./fungisamurai/slides/sketch.jpg": "a671",
	"./fungisamurai/slides/total.jpg": "a6a8",
	"./fungisamurai/thumbnail.jpg": "b4cf",
	"./hrfestival/header.jpg": "5342",
	"./hrfestival/slides/2018poster.jpg": "a44f",
	"./hrfestival/slides/2019poster.jpg": "cb8c",
	"./hrfestival/slides/2019tshirt.jpg": "7eb1",
	"./hrfestival/slides/artposter.jpg": "c521",
	"./hrfestival/slides/explorer.jpg": "b9e1",
	"./hrfestival/slides/forte.jpg": "ef07",
	"./hrfestival/slides/instagrammock.jpg": "5b03",
	"./hrfestival/slides/sage.jpg": "fb1c",
	"./hrfestival/slides/stage.jpg": "db62",
	"./hrfestival/thumbnail.jpg": "e1ee",
	"./mopay/header.jpg": "956d",
	"./mopay/slides/addition.jpg": "c125",
	"./mopay/slides/card.jpg": "26d7",
	"./mopay/slides/construction.jpg": "4b5a",
	"./mopay/slides/logo.jpg": "a9d3",
	"./mopay/slides/moodboard.jpg": "4fb5",
	"./mopay/slides/sketch.jpg": "8e51",
	"./mopay/slides/table.jpg": "29f0",
	"./mopay/thumbnail.jpg": "fed2",
	"./nespresso/header.jpg": "bbf4",
	"./nespresso/slides/facebook.jpg": "351d",
	"./nespresso/slides/poster.jpg": "d639",
	"./nespresso/slides/street_mockup.jpg": "b4b1",
	"./nespresso/thumbnail.jpg": "3f8d",
	"./portrait/header.jpg": "2127",
	"./portrait/thumbnail.jpg": "b612",
	"./sketch/header.jpg": "4d3d",
	"./sketch/slides/bojack.jpg": "848f",
	"./sketch/slides/bulldog.jpg": "7f17",
	"./sketch/slides/fire.jpg": "73dc",
	"./sketch/slides/hilda.jpg": "474a",
	"./sketch/slides/orono.jpg": "ce8b",
	"./sketch/slides/steam.jpg": "b896",
	"./sketch/slides/tacos.jpg": "d2d0",
	"./sketch/thumbnail.jpg": "c843",
	"./square/header.jpg": "56ee",
	"./square/slides/1.jpg": "6f5c",
	"./square/slides/10.jpg": "ac3e",
	"./square/slides/11-12.jpg": "01e2",
	"./square/slides/11.jpg": "7128",
	"./square/slides/12.jpg": "1518",
	"./square/slides/2.jpg": "ba5d",
	"./square/slides/3.jpg": "ae22",
	"./square/slides/4.jpg": "dc37",
	"./square/slides/5.jpg": "3808",
	"./square/slides/6.jpg": "4ca6",
	"./square/slides/7.jpg": "e2af",
	"./square/slides/8.jpg": "3b72",
	"./square/slides/9.jpg": "6366",
	"./square/thumbnail.jpg": "92c2",
	"./tlc/front tlc.jpg": "8b2e",
	"./tlc/header.jpg": "83ae",
	"./tlc/slides/Back.jpg": "9413",
	"./tlc/slides/female.jpg": "d88b",
	"./tlc/slides/logo.jpg": "da00",
	"./tlc/slides/male.jpg": "5ebc",
	"./tlc/slides/mood.jpg": "037f",
	"./tlc/slides/wow.jpg": "192c",
	"./tlc/thumbnail.jpg": "90ed",
	"./urdrugs/header.jpg": "0004",
	"./urdrugs/slides/alcol.jpg": "e8e9",
	"./urdrugs/slides/coca.jpg": "b2f4",
	"./urdrugs/slides/mashroom.jpg": "d548",
	"./urdrugs/slides/opioids.jpg": "0102",
	"./urdrugs/slides/smile.jpg": "9b28",
	"./urdrugs/slides/weed.jpg": "beeb",
	"./urdrugs/thumbnail.jpg": "15a2",
	"./whatever/header.jpg": "1fbe",
	"./whatever/thumbnail.jpg": "ee8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51cf";